async function getCharges(subscriptions, session) {
  return await recharge.charge.listCharges(session, {
    limit: 30,
    sort_by: "scheduled_at-asc",
    purchase_item_ids: subscriptions,
    status: ["queued"]
  });
}

async function processSendNow(subscriptions) {
  const session = await recharge.auth.loginCustomerPortal();
  const chargesResponse = await getCharges(subscriptions, session);
  if (chargesResponse && chargesResponse.charges) {
    const nextOrderDate = new Date(Math.min(...chargesResponse.charges.map(element => { return new Date(element.scheduled_at) })));
    const chargesToProcess = chargesResponse.charges.filter(c => (new Date(c.scheduled_at) - nextOrderDate) === 0)
    for (var i = 0; i < chargesToProcess.length; ++i) {
      await recharge.charge.processCharge(
        session,
        chargesToProcess[i].id
      );
    }
  }
  $(".send-now-modal .primary-btn").attr("disabled", false);
  $(".send-now-modal .primary-btn span").show();
  $(".send-now-modal .primary-btn #spinner-send").hide();
  $(".send-now-modal").hide();
  $(".send-now-confirmation").show();
}

$(async function() {
  window.processSendNow = subscriptions => {
    processSendNow(subscriptions);
  };
  $(".send-now-confirmation button").on("click", () => {
    $(".send-now-confirmation").hide();
    window.refreshShipments();
    window.refresh();
  });
});
